import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { resolveRef, resolveUnref, tryOnScopeDispose } from '~/utils/VueUseHelpers';
function useScrollLock(element) {
  var initialState = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var isLocked = ref(initialState);
  watch(resolveRef(element), function (el) {
    if (el) {
      var ele = el;
      if (isLocked.value) ele.style.overflow = 'hidden';
    }
  }, {
    immediate: true
  });
  var lock = function lock() {
    var ele = resolveUnref(element);
    if (!ele || isLocked.value) return;
    ele.style.overflow = 'hidden';
    isLocked.value = true;
  };
  var unlock = function unlock() {
    var ele = resolveUnref(element);
    if (!ele || !isLocked.value) return;
    ele.style.overflow = '';
    isLocked.value = false;
  };
  tryOnScopeDispose(unlock);
  return computed({
    get: function get() {
      return isLocked.value;
    },
    set: function set(v) {
      if (v) lock();else unlock();
    }
  });
}
export default function () {
  var locks = [useScrollLock(document.documentElement)];
  var lockScroll = function lockScroll() {
    return locks.forEach(function (l) {
      return l.value = true;
    });
  };
  var unlockScroll = function unlockScroll() {
    return locks.forEach(function (l) {
      return l.value = false;
    });
  };
  return {
    lockScroll: lockScroll,
    unlockScroll: unlockScroll
  };
}